<template>
	<v-sheet class="member" style="height: calc(100vh - 88px)">
		<template v-if="contentLoaded">
			<v-layout class="align-center light-blue-bg px-4 py-2">
				<v-flex md12>
					<div class="d-flex">
						<p class="my-auto font-level-3-bold">
							<ShowValue :object="member" object-key="display_name" label="user name"></ShowValue>
							<v-chip color="cyan" class="ml-2 mr-2" label text-color="white">{{ member.barcode }}</v-chip>
						</p>
						<v-spacer></v-spacer>
						<v-btn
							v-on:click="doAction('edit')"
							color="blue darken-4 text-white"
							class="ml-2"
							depressed
							tile
						>
							<v-icon small left>mdi-pencil</v-icon>Edit
						</v-btn>
						<v-btn v-on:click="backToListing('users')" color="" class="ml-2" depressed tile>
							<v-icon small left>mdi-keyboard-backspace</v-icon>Back
						</v-btn>
						<template v-if="getPermission('user:update')">
							<v-btn
								v-if="!member.is_resigned"
								v-on:click="doAction('edit')"
								color="blue darken-4 text-white"
								class="ml-2"
								depressed
								tile
								><v-icon small left>mdi-pencil</v-icon>Edit</v-btn
							>
						</template>
						<template v-if="getPermission('user:delete')">
							<v-btn
								v-if="!member.is_owner"
								v-on:click="doAction('delete')"
								color="blue darken-4 text-white"
								class="ml-2"
								depressed
								tile
								><v-icon small left>mdi-delete</v-icon>Delete</v-btn
							>
						</template>
						<template v-if="!member.is_owner">
							<template v-if="getPermission('user:update')">
								<v-btn
									v-if="member.activated"
									v-on:click="doAction('deactivate')"
									color="blue darken-4 text-white"
									class="ml-2"
									depressed
									tile
									><v-icon small left>mdi-cancel</v-icon>De-activate</v-btn
								>
								<v-btn
									v-else
									v-on:click="doAction('activate')"
									color="blue darken-4 text-white"
									class="ml-2"
									depressed
									tile
									><v-icon small left>mdi-check-all</v-icon>Activate</v-btn
								>
							</template>
						</template>
					</div>
					<div class="d-flex mt-4">
						<div class="w-15 pr-3">
							<ImageTemplate circle :src="member.image"></ImageTemplate>
						</div>

						<div>
							<div class="d-flex flex-wrap width-85">
								<div class="width-33">
									<div class="mt-2">
										<span class="fw-600">Email : </span>
										<span class="fw-500">
											<ShowValue :object="member" object-key="email" label="email id"></ShowValue>
										</span>
									</div>
								</div>
								<div class="width-33">
									<div class="mt-2">
										<span class="fw-600"> Phone Number : </span>
										<span class="fw-500">
											<ShowValue :object="member" object-key="phone_number" label="phone number"></ShowValue>
										</span>
									</div>
								</div>
								<div class="width-33">
									<div class="mt-2">
										<span class="fw-600">Security Code: </span>
										<span class="fw-500">
											<ShowValue :object="member" object-key="security_code" label="security code">
											</ShowValue>
											<v-tooltip top content-class="custom-top-tooltip" v-if="member.security_code">
												<template v-slot:activator="{ on, attrs }">
													<span v-bind="attrs" v-on="on">
														<v-icon
															@click="copySecurityCode(member.security_code)"
															small
															class="ml-3 cursor-pointer"
															color="green"
															>mdi-content-copy</v-icon
														>
													</span>
												</template>
												<span>Copy Security Code</span>
											</v-tooltip>
										</span>
									</div>
								</div>
								<div class="width-33" v-if="member.role">
									<div class="mt-2">
										<span class="fw-600">Role : </span>
										<span class="fw-500">
											<ShowValue :object="member.role" object-key="role" label="role"> </ShowValue>
										</span>
									</div>
								</div>
								<div class="width-33" v-if="member.is_resigned">
									<div class="mt-2">
										<span class="fw-600">Resigned Date : </span>
										<span class="fw-500">
											<ShowValue :object="member" object-key="resigned_date" label="resigned date">
											</ShowValue>
										</span>
									</div>
								</div>
								<div class="width-33" v-if="member.is_resigned">
									<div class="mt-2">
										<span class="fw-600">Resigned Reason : </span>
										<span class="fw-500">
											<ShowValue :object="member" object-key="resigned_reason" label="resigned reason">
											</ShowValue>
										</span>
									</div>
								</div>
								<div class="width-33">
									<div class="mt-2">
										<span class="fw-600 mr-2">Created Date: </span>
										<span class="fw-500 no-wrap">
											{{ formatDateTime(member.added_at) }}
										</span>
									</div>
								</div>
								<div class="width-33">
									<div class="mt-2">
										<span class="fw-600">Created by : </span>
										<span class="fw-500 no-wrap">
											<ShowValue :object="member" object-key="created_by" label="Created by"></ShowValue>
										</span>
									</div>
								</div>
								<div class="width-33">
									<div class="mt-2">
										<span class="fw-600">Updated Date : </span>
										<span class="fw-500 no-wrap">
											<template v-if="member.updated_at">
												{{ formatDateTime(member.updated_at) }}
											</template>
											<em v-else class="text-muted">no updated</em>
										</span>
									</div>
								</div>
								<div class="width-33">
									<div class="mt-2">
										<span class="fw-600">Updated by : </span>
										<span class="fw-500 no-wrap">
											<ShowValue :object="member" object-key="updated_by" label="updated by"> </ShowValue>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</v-flex>
			</v-layout>
			<div>
				<v-tabs
					v-model="memberTab"
					background-color="transparent"
					color="blue"
					class="custom-tab-transparent"
					active-class="blue darken-4 text-white"
					hide-slider
				>
					<v-tab href="#permission" v-if="!member.is_resigned">
						<v-icon small left>mdi-history</v-icon>Permissions</v-tab
					>
					<v-tab href="#password" v-if="!member.is_resigned">
						<v-icon small left>mdi-history</v-icon>Change Password</v-tab
					>
					<v-tab href="#signature"> <v-icon small left>mdi-draw</v-icon>Signature</v-tab>
					<v-tab href="#event"> <v-icon small left>mdi-history</v-icon>Logs</v-tab>
				</v-tabs>

				<v-tabs-items v-model="memberTab">
					<v-tab-item value="permission">
						<!-- v-if="false" -->
						<MemberPermission v-model="db_permissions" :uuid="uuid" v-on:success="getMember()">
						</MemberPermission>
					</v-tab-item>
					<v-tab-item value="password" v-if="!member.is_resigned">
						<div class="mx-4">
							<div class="overflow-y" style="max-height: calc(100vh - 250px)">
								<v-layout class="p-4 border-bottom-light-grey min-height-57px">
									<v-flex class="font-level-3-bold my-auto">
										<span class="detail-svg-icon mr-2">
											<!--begin::Svg Icon-->
											<inline-svg :src="$assetURL('media/custom-svg/member-color.svg')" />
											<!--end::Svg Icon-->
										</span>
										Change Password
									</v-flex>
									<v-flex class="font-level-3-bold my-auto float-right">
										<v-btn
											:loading="pageLoading"
											class="white--text mr-2 float-right"
											depressed
											color="blue darken-4"
											tile
											:disabled="pageLoading"
											v-on:click="updatePassword()"
										>
											Update Password
										</v-btn>
									</v-flex>
								</v-layout>
							</div>
						</div>
						<v-form
							ref="passwordForm"
							v-model.trim="formValid"
							lazy-validation
							v-on:submit.stop.prevent="updatePassword"
						>
							<v-row>
								<v-col md="6" class="py-0 pt-4" offset-md="3">
									<TextInput
										hide-details
										:disabled="pageLoading"
										:type="show1 ? 'text' : 'password'"
										:loading="pageLoading"
										:append-outer-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
										v-on:click:append-outer="show1 = !show1"
										id="first-name"
										placeholder="Password"
										:rules="[
											vrules.required(password, 'New Password'),
											vrules.minLength(password, 'New Password', 8),
											vrules.maxLength(password, 'New Password', 16),
										]"
										:class="{
											required: !password,
										}"
										v-model="password"
									></TextInput>
								</v-col>
								<v-col md="6" class="py-0" offset-md="3">
									<TextInput
										hide-details
										:disabled="pageLoading"
										:type="show3 ? 'text' : 'password'"
										:loading="pageLoading"
										:append-outer-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
										v-on:click:append-outer="show3 = !show3"
										id="first-name"
										placeholder="Confirm Password"
										:rules="[
											vrules.required(password_confirmation, 'Confirm Password'),
											vrules.confirmPassword(password_confirmation, 'Confirm Password', password),
											vrules.minLength(password_confirmation, 'Confirm Password', 8),
											vrules.maxLength(password_confirmation, 'Confirm Password', 16),
										]"
										:class="{
											required: !password_confirmation,
										}"
										v-model="password_confirmation"
									></TextInput>
								</v-col>
							</v-row>
						</v-form>
					</v-tab-item>
					<v-tab-item value="event">
						<EventListing
							v-if="memberTab == 'event'"
							class="mx-4"
							type-text="User"
							type="member"
							:type-uuid="uuid"
						></EventListing>
					</v-tab-item>
					<v-tab-item value="signature">
						<Signature class="mx-4" v-if="memberTab === 'signature' && member" :member="member" />
					</v-tab-item>
				</v-tabs-items>
			</div>
			<DeleteTemplate
				type="User"
				:delete-text="deleteText"
				v-on:success="goBack()"
				v-on:close="deleteDialog = false"
				:delete-dialog="deleteDialog"
				:delete-url="deleteURL"
				:delete-note="
					member.activated
						? 'To preserve associated records, you could de-activate the User instead.'
						: null
				"
			>
				<template v-if="member.activated" v-slot:extra-btn>
					<v-btn
						class="white--text"
						depressed
						color="blue darken-4"
						tile
						v-on:click="
							deleteDialog = false;
							deactivateDialog = true;
						"
					>
						De-activate
					</v-btn>
				</template>
			</DeleteTemplate>
			<DeactivateTemplate
				type="Member"
				:deactivate-text="deactivateText"
				v-on:success="goBack()"
				v-on:close="deactivateDialog = false"
				:deactivate-dialog="deactivateDialog"
				:deactivate-url="deactivateURL"
			>
			</DeactivateTemplate>
			<ActivateTemplate
				type="Member"
				:activate-text="activateText"
				v-on:success="goBack()"
				v-on:close="activateDialog = false"
				:activate-dialog="activateDialog"
				:activate-url="activateURL"
			>
			</ActivateTemplate>
			<ResignTemplate
				type="Member"
				v-on:success="goBack()"
				v-on:close="resignDialog = false"
				:resign-dialog="resignDialog"
				:uuid="uuid"
			>
			</ResignTemplate>
		</template>
		<template v-else>
			<div class="mx-20 my-40 text-center">
				<v-progress-linear color="orange darken-2" indeterminate height="6"></v-progress-linear>
			</div>
		</template>
	</v-sheet>
</template>
<style>
.w-15 {
	width: 125px;
}
</style>
<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GetMember, UpdateMemberPassword } from "@/core/lib/member.lib";
import ImageTemplate from "@/view/components/Image";
import ShowValue from "@/view/components/ShowValue";
import DeleteTemplate from "@/view/components/DeleteTemplate";
import ActivateTemplate from "@/view/components/ActivateTemplate";
import ResignTemplate from "@/view/components/ResignTemplate";
import DeactivateTemplate from "@/view/components/DeactivateTemplate";
import EventListing from "@/view/components/EventListing";
import Signature from "@/view/components/Signature";

import MemberPermission from "@/view/module/members/MemberPermission";
import TextInput from "@/view/components/TextInput";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";

export default {
	name: "member-detail",
	title: "Detail Member",
	data() {
		return {
			uuid: null,
			barcode: null,
			activateText: null,
			activateURL: null,
			deactivateText: null,
			deactivateURL: null,
			deleteText: null,
			deleteURL: null,
			password_confirmation: null,
			password: null,
			formValid: true,
			deleteDialog: false,
			addressDialog: false,
			resignDialog: false,
			deactivateDialog: false,
			activateDialog: false,
			contentLoaded: false,
			pageLoading: false,
			show1: false,
			show3: false,
			memberTab: "permission",
			member: {},
			db_permissions: [],
		};
	},
	methods: {
		doAction(param) {
			switch (param) {
				case "edit":
					this.$router.push({
						name: "user-update",
						params: { uuid: this.uuid },
						query: { t: new Date().getTime() },
					});
					break;
				case "delete":
					this.deleteDialog = true;
					break;
				case "deactivate":
					this.deactivateDialog = true;
					break;
				case "activate":
					this.activateDialog = true;
					break;
				case "new-address":
					this.addressDialog = true;
					break;
				case "resign":
					this.resignDialog = true;
					break;
				case "print-label":
					break;
			}
		},
		copySecurityCode(code) {
			navigator.clipboard.writeText(code);
			this.$store.commit(SET_MESSAGE, [
				{ model: true, message: `<b>${code}</b> - successfully coppied.` },
			]);
		},
		getMember() {
			GetMember(this.uuid)
				.then((data) => {
					this.barcode = data.barcode;
					this.db_permissions = data.permissions;
					// console.log("this.db_permissions ",this.db_permissions );
					this.member = data;
					this.deleteText = `#${data.barcode} - ${data.display_name}`;
					this.deleteURL = `member/${data.uuid}`;
					this.activateText = `${data.name}`;
					this.activateURL = `member/${data.uuid}/activate`;
					this.deactivateText = `${data.display_name}`;
					this.deactivateURL = `member/${data.uuid}/de-activate`;
					this.$store.dispatch(SET_BREADCRUMB, [
						{ text: "User", disabled: true },
						{ text: "Detail", disabled: true },
						{ text: this.barcode, disabled: true },
					]);
				})
				.catch((error) => {
					this.goBack();
					this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
					this.logError(error);
				})
				.finally(() => {
					this.pageLoading = false;
					this.contentLoaded = true;
				});
		},
		updatePassword() {
			const _this = this;
			const formErrors = _this.validateForm(_this.$refs.passwordForm);
			if (formErrors.length) {
				_this.$store.commit(SET_ERROR, _this.errors.concat(formErrors));
				return false;
			}

			if (!_this.$refs.passwordForm.validate()) {
				return false;
			}

			UpdateMemberPassword(this.uuid, { password: this.password })
				.then(() => {
					this.password = null;
					this.password_confirmation = null;
					this.getMember();
					this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Password has been updated." },
					]);
				})
				.catch((error) => {
					this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
					this.logError(error);
				})
				.finally(() => {
					this.pageLoading = false;
					this.contentLoaded = true;
				});
		},
	},
	components: {
		ShowValue,
		Signature,
		EventListing,
		ImageTemplate,
		DeleteTemplate,
		ActivateTemplate,
		DeactivateTemplate,
		TextInput,
		ResignTemplate,
		MemberPermission,
	},
	mounted() {
		this.$store.dispatch(SET_BREADCRUMB, [
			{ text: "User", disabled: true },
			{ text: "Detail", disabled: true },
		]);

		const { uuid } = this.$route.params;
		this.uuid = uuid;
		if (!this.uuid) {
			this.goBack();
		}
		this.getMember();
	},
	beforeDestroy() {
		this.$store.dispatch(SET_BREADCRUMB, []);
	},
	computed: {
		...mapGetters(["errors", "localDB"]),
		addStatus() {
			if (this.member && this.member.is_resigned && this.member.is_resigned == 1) {
				return true;
			} else {
				return false;
			}
		},
	},
};
</script>
